module.exports = __webpack_public_path__ + "static/media/mongodb.b30ceef7.svg";